module.exports = __webpack_public_path__ + "logo.png?27324c4cd1070eeb9106f7253dd6d2ef";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 35
// module chunks = 0